import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { data } from 'jquery';
import { EstadoUsuarioI } from 'src/app/modelos/estadoUsuario.intreface';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { OperacionI } from 'src/app/modelos/operacionEsta.interface';
import { TipoUsuarioI } from 'src/app/modelos/tipoUsuario.interface';
import { UsuarioI } from 'src/app/modelos/usuario.interface';
import { CargandoService } from 'src/app/plantillas/cargando/cargando.service';
import { AlertasService } from 'src/app/servicios/alertas/alertas.service';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { ToastrService } from 'ngx-toastr';
import { DivipolaI } from 'src/app/modelos/Divipola';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-usuariochv',
  templateUrl: './usuariochv.component.html',
  styleUrls: ['./usuariochv.component.css']
})
export class UsuariochvComponent implements OnInit {

  buscarFuente: String;
  Operacion:OperacionI;
  fuentesChv : fuenteI[];
  FuenteUsuario : fuenteI;
  btnguardar : Boolean;
  NuevoUsuario : UsuarioI;
  idNuevoUsu : String;
  nombreAux : String;
  UsernameNuevo : String;
  longitudNombreAux : Number;
  //email1 : String;
  //email2: String;
  tipoUsuario : TipoUsuarioI;
  estadoUsuario : EstadoUsuarioI;
  usuarios : UsuarioI[];
  idFuenteFivi : BigInteger;
  existeUsuario : UsuarioI;
  camposdatosUsuarios : Boolean;
  infoFuente : Boolean = false;
  continuar : Boolean;

  NombreEntidad : String;
  Nit : String;
  codigoEntidad : String;
  Direccion : String;
  NombreComercial : String;
  Departamento : String;
  Municipio : String;
  Telefono : String;
  AuxDeptoMuni : DivipolaI;

  @ViewChild('openmodalcargando') openmodalcargando: ElementRef;
  @ViewChild('closemodacargando') closemodacargando: ElementRef;

  constructor(
    private api:ApiService,
    private loadingService: CargandoService,
    private router:Router,
    private alerta:AlertasService,
    private appService:AppServiceService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.btnguardar = false;
    this.camposdatosUsuarios = true;

    this.NuevoUsuario = new UsuarioI;
    this.NuevoUsuario.tipoIdent = "";
    this.NuevoUsuario.identificacion = "";
    this.NuevoUsuario.nombres = "";
    this.NuevoUsuario.telefono = "";
    this.NuevoUsuario.extencion = "";
    this.NuevoUsuario.cargo = "";
    this.NuevoUsuario.correo = "";

    this.tipoUsuario = new TipoUsuarioI;
    this.tipoUsuario.idTipoUsuario = 4;
    this.tipoUsuario.nombreTipo = "CHV";
    this.tipoUsuario.desTipo = "Fuente CHV";
    this.tipoUsuario.usTipoTipo = "Fuente";

    this.estadoUsuario = new EstadoUsuarioI;
    this.estadoUsuario.idEstadoUsuario = "1";
    this.estadoUsuario.nombreEstado = "Activo";
    this.estadoUsuario.desEstado = "Activo";

    let operacion: OperacionI;
    operacion = new OperacionI();
    operacion.id =1;
    operacion.descripcion= "Cartera Hipotecaria de Vivienda";
    operacion.nombre = "CHV";

    this.api.getFuentesByOpe(operacion).subscribe(data=>{
      //console.log(data);
      this.fuentesChv = data;
    },error=>{
      console.log(error);
    });

    this.api.getIdConsecutivo().subscribe(data=>{
      this.idNuevoUsu = data;
      //console.log(this.idNuevoUsu);
      this.NuevoUsuario.id = this.idNuevoUsu;
      this.NuevoUsuario.tipoUsuario = this.tipoUsuario;
      this.NuevoUsuario.estadoUsuario = this.estadoUsuario;
      this.nombreUsuario();
      //console.log(this.nombreAux);
    },error=>{
      console.log(error);
    });
  }

  nombreUsuario(){
    this.nombreAux = String(this.idNuevoUsu);
    //console.log(this.nombreAux);
    this.longitudNombreAux = this.idNuevoUsu.length;
    //console.log(this.idNuevoUsu.length);
    for(let i = this.nombreAux.length ; i < 5 ; i++ ){
      this.nombreAux = "0" + this.nombreAux;
      //console.log(this.nombreAux);
    }
    if (this.nombreAux.length == 5){
      this.nombreAux = "CHV" + this.nombreAux;
      this.NuevoUsuario.username = this.nombreAux;
    }
  }

  BuscarFuente(buscarFuente){

    if(buscarFuente == "" || buscarFuente == null){
      this.toastr.warning('Ingrese el NIT o nombre de la fuente', 'Advertencia!');

      this.camposdatosUsuarios = true;
      this.infoFuente = false;

      this.NombreEntidad = "";
      this.Nit = "";
      this.codigoEntidad = "";
      this.Direccion = "";
      this.NombreComercial = "";
      this.Telefono = "";
      this.Departamento = "";
      this.Municipio = "";

      this.email1.setValue("");
      this.email2.setValue("");
      this.tipoDocumento.setValue("");
      this.numIdentificacion.setValue("");
      this.nombres.setValue("");
      this.correo.setValue("");
      this.telefono.setValue("");
      this.extencion.setValue("");
      this.cargo.setValue("");

      this.enabled();
      return;
    }

    this.FuenteUsuario = new fuenteI;

    this.FuenteUsuario = this.fuentesChv.find(function(fuente) {
      if (fuente.nit === buscarFuente) return fuente;
      if (fuente.nombEntidad === buscarFuente) return fuente;
      else return null;
    });

    if(this.FuenteUsuario == null){
      this.toastr.warning('La fuente no esta registrada', 'Advertencia!');

      this.camposdatosUsuarios = true;

      this.NombreEntidad = "";
      this.Nit = "";
      this.codigoEntidad = "";
      this.Direccion = "";
      this.NombreComercial = "";
      this.Telefono = "";
      this.Departamento = "";
      this.Municipio = "";
    }

    this.api.getMuniByCodigo(this.FuenteUsuario.muni).subscribe(depmuni=>{
      this.AuxDeptoMuni = depmuni;
      this.Departamento = this.AuxDeptoMuni.departamento;
      this.Municipio = this.AuxDeptoMuni.nommpio;
    },error=>{
      console.log(error);
    });

    this.NombreEntidad = this.FuenteUsuario.nombEntidad;
    this.Nit = this.FuenteUsuario.nit;
    this.codigoEntidad = this.FuenteUsuario.codEnti;
    this.Direccion = this.FuenteUsuario.direccion;
    this.NombreComercial = this.FuenteUsuario.nombEntidad;
    this.Telefono = this.FuenteUsuario.telefono;

    if (this.FuenteUsuario != null){
      this.infoFuente = true;
      this.api.existeUsuarioFuente(this.FuenteUsuario.id).subscribe(data=>{
        this.existeUsuario = data;
        if (this.existeUsuario == null){
          this.camposdatosUsuarios = false;
          this.btnguardar = false;
          this.NuevoUsuario.fuente = this.FuenteUsuario.id;
          this.NuevoUsuario.password = this.FuenteUsuario.nit.split("-",1)[0];
          this.enabled();
        } else {
          this.camposdatosUsuarios = true;
          this.btnguardar = true;
          this.toastr.warning('Existe un usuario para la fuente seleccionada', 'Advertencia!');
        }
      },error=>{
        console.log(error);
      });
    } else {
      this.btnguardar = true;
      this.toastr.warning('La fuente no esta registrada', 'Advertencia!');
    }
  }

  email1 = new FormControl('',[Validators.required, Validators.email, Validators.pattern(/^[A-Za-z0-9@._-]*$/)]);
  email2 = new FormControl('',[Validators.required, Validators.email, Validators.pattern(/^[A-Za-z0-9@._-]*$/)]);
  tipoDocumento= new FormControl('',[Validators.required]);
	numIdentificacion= new FormControl('',[Validators.required, Validators.pattern('[0-9 ]*')]);
	nombres= new FormControl('',[Validators.required, Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚñÑ ]*')]);
	correo= new FormControl('',[Validators.required, Validators.email]);
  telefono= new FormControl('',[Validators.required, Validators.pattern('[0-9 ]*')]);
  extencion= new FormControl('',[Validators.required, Validators.pattern('[0-9 ]*')]);
  cargo= new FormControl('',[Validators.required, Validators.pattern('[a-zA-ZáéíóúÁÉÍÓÚñÑ ]*')]);

  UpdateVariableNuevaFuente(){
    this.NuevoUsuario.tipoIdent = this.tipoDocumento.value;
    this.NuevoUsuario.identificacion = this.numIdentificacion.value;
    this.NuevoUsuario.nombres = this.nombres.value;
    this.NuevoUsuario.correo = this.correo.value;
    this.NuevoUsuario.telefono = this.telefono.value;
    this.NuevoUsuario.extencion = this.extencion.value;
    this.NuevoUsuario.cargo = this.cargo.value;
  }

  enabled(){
    if (this.camposdatosUsuarios) {
      this.tipoDocumento.disable();
      this.numIdentificacion.disable();
      this.nombres.disable();
      this.telefono.disable();
      this.extencion.disable();
      this.cargo.disable();
      this.email1.disable();
      this.email2.disable();
    } else {
      this.tipoDocumento.enable();
      this.numIdentificacion.enable();
      this.nombres.enable();
      this.telefono.enable();
      this.extencion.enable();
      this.cargo.enable();
      this.email1.enable();
      this.email2.enable();
    }
  }

  VerificarCorreo(){
    if(this.email1.value==this.email2.value) {
      this.correo.setValue(this.email1.value);
      this.UpdateVariableNuevaFuente();
    }
  }

  checkEmailValidity() {
    const atIndex = this.correo.value.indexOf('@');
    if (atIndex !== -1) {
      const domain = this.correo.value.substring(atIndex + 1);
      if (domain.indexOf('.') !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  checkEmailValidity1() {
    const atIndex = this.email1.value.indexOf('@');
    if (atIndex !== -1) {
      const domain = this.email1.value.substring(atIndex + 1);
      if (domain.indexOf('.') !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  checkEmailValidity2() {
    const atIndex = this.email2.value.indexOf('@');
    if (atIndex !== -1) {
      const domain = this.email2.value.substring(atIndex + 1);
      if (domain.indexOf('.') !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  VerificarCampos(){

    if (!this.infoFuente){
      this.toastr.warning('Ingrese el NIT o nombre de la fuente.', 'Advertencia!');
    } else if (this.tipoDocumento.hasError('required')){
      this.toastr.warning('Debe seleccionar tipo de identificación.', 'Advertencia!');
    } else if (this.numIdentificacion.hasError('required')){
      this.toastr.warning('Ingresar número de identificación.', 'Advertencia!');
    } else if (this.numIdentificacion.value.length < 6){
      this.toastr.warning('El número de identificación debe contar con mínimo 6 caracteres.', 'Advertencia!');
    } else if (this.numIdentificacion.value.length > 10){
      this.toastr.warning('El número de identificación debe contar con máximo 10 caracteres.', 'Advertencia!');
    } else if (this.numIdentificacion.hasError('pattern')){
      this.toastr.warning('El número de identificación contiene caracteres no permitidos.', 'Advertencia!');
    } else if (this.nombres.hasError('required')){
      this.toastr.warning('Ingresar nombre.', 'Advertencia!');
    } else if (this.nombres.value.length < 10){
      this.toastr.warning('El nombre del responsable debe contar con mínimo 10 caracteres.', 'Advertencia!');
    } else if (this.nombres.value.length > 100){
      this.toastr.warning('El nombre del responsable debe contar con máximo 100 caracteres.', 'Advertencia!');
    } else if (this.nombres.hasError('pattern')){
      this.toastr.warning('El nombre del responsable contiene caracteres no permitidos.', 'Advertencia!');
    } else if (this.email1.hasError('required')){
      this.toastr.warning('Ingresar correo.', 'Advertencia!');
    } else if (this.email1.hasError('email')){
      this.toastr.warning('Correo no valido.', 'Advertencia!');
    } else if (this.email1.hasError('pattern')){
      this.toastr.warning('Correo contiene caracteres no permitidos.', 'Advertencia!');
    } else if (this.email1.value.length < 10 ){
      this.toastr.warning('Correo debe tener mínimo 10 caracteres.', 'Advertencia!');
    } else if (this.email1.value.length > 40 ){
      this.toastr.warning('Correo debe tener máximo 40 caracteres.', 'Advertencia!');
    } else if (this.email2.hasError('required')){
      this.toastr.warning('Confirmar correo.', 'Advertencia!');
    } else if (this.email2.hasError('email')){
      this.toastr.warning('Confirmar correo no valido.', 'Advertencia!');
    } else if (this.email2.hasError('pattern')){
      this.toastr.warning('Confirmar correo contiene caracteres no permitidos.', 'Advertencia!');
    } else if (this.email2.value.length < 10 ){
      this.toastr.warning('Confirmar correo debe tener mínimo 10 caracteres.', 'Advertencia!');
    } else if (this.email2.value.length > 40 ){
      this.toastr.warning('Confirmar correo debe tener máximo 40 caracteres.', 'Advertencia!');
    } else if(this.email1.value!=this.email2.value) {
      this.toastr.warning('El correo no es igual.', 'Advertencia!');
    } else if (!this.checkEmailValidity1()||!this.checkEmailValidity2()){
      this.toastr.warning('Correo no valido.', 'Advertencia!');
    }/* else if (this.correo.hasError('required')){
      this.toastr.warning('Ingresar correo.', 'Advertencia!');
    } else if (this.correo.hasError('email')||!this.checkEmailValidity()){
      this.toastr.warning('Correo no valido.', 'Advertencia!');
    } else if (this.correo.value.length < 10 ){
      this.toastr.warning('Correo debe tener mínimo 10 caracteres.', 'Advertencia!');
    } else if (this.correo.value.length > 40 ){
      this.toastr.warning('Correo debe tener máximo 40 caracteres.', 'Advertencia!');
    }*/ else if (this.telefono.hasError('required')){
      this.toastr.warning('Ingresar teléfono.', 'Advertencia!');
    } else if (this.telefono.hasError('pattern')){
      this.toastr.warning('El teléfono del responsable contiene caracteres no permitidos.', 'Advertencia!');
    } else if (this.telefono.value.length < 6 ){
      this.toastr.warning('Teléfono debe tener mínimo 6 caracteres.', 'Advertencia!');
    } else if (this.telefono.value.length > 10 ){
      this.toastr.warning('Teléfono debe tener máximo 10 caracteres.', 'Advertencia!');
    } else if (this.extencion.hasError('required')){
      this.toastr.warning('Ingresar extención.', 'Advertencia!');
    } else if (this.extencion.hasError('pattern')){
      this.toastr.warning('La extención del responsable contiene caracteres no permitidos.', 'Advertencia!');
    } else if (this.extencion.value.length < 2 ){
      this.toastr.warning('Extención debe tener mínimo 2 caracteres.', 'Advertencia!');
    } else if (this.extencion.value.length > 5 ){
      this.toastr.warning('Extención debe tener máximo 5 caracteres.', 'Advertencia!');
    } else if (this.cargo.hasError('required')){
      this.toastr.warning('Ingresar cargo.', 'Advertencia!');
    } else if (this.cargo.hasError('pattern')){
      this.toastr.warning('El cargo contiene caracteres no permitidos.', 'Advertencia!');
    } else if (this.cargo.value.length < 5 ){
      this.toastr.warning('El cargo debe tener mínimo 5 caracteres.', 'Advertencia!');
    } else if (this.cargo.value.length > 20 ){
      this.toastr.warning('El cargo debe tener máximo 20 caracteres.', 'Advertencia!');
    }
  }

  BTNguardar(){
    if(this.tipoDocumento.hasError('required') ||
      this.numIdentificacion.hasError('required') ||
      this.numIdentificacion.value.length < 6 ||
      this.numIdentificacion.value.length > 10 ||
      this.numIdentificacion.hasError('pattern') ||
      this.nombres.hasError('required') ||
      this.nombres.value.length < 10 ||
      this.nombres.value.length > 100 ||
      this.nombres.hasError('pattern') ||
      this.email1.hasError('required')||
      this.email1.hasError('email')||
      !this.checkEmailValidity1() ||
      this.email2.hasError('required')||
      this.email2.hasError('email')||
      !this.checkEmailValidity2() ||
      this.correo.hasError('required') ||
      this.correo.hasError('email') ||
      this.correo.value.length < 10 ||
      !this.checkEmailValidity() ||
      this.correo.value.length > 40 ||
      this.telefono.hasError('required') ||
      this.telefono.hasError('pattern') ||
      this.telefono.value.length < 7 ||
      this.telefono.value.length > 10 ||
      this.extencion.hasError('required') ||
      this.extencion.hasError('pattern') ||
      this.extencion.value.length < 2 ||
      this.extencion.value.length > 5 ||
      this.cargo.hasError('required') ||
      this.cargo.hasError('pattern') ||
      this.cargo.value.length < 5 ||
      this.cargo.value.length > 20
    ){
      return true;
    }else {
      return false;
    }
  }

  guardar(){
    this.btnguardar = true;
    this.continuar = true;
    console.log(this.NuevoUsuario);
    this.api.nuevoUsuario(this.NuevoUsuario).subscribe(data=>{
      this.toastr.success('Usuario creado.', 'OK!');
      this.router.navigate(['usuarios']);
    },error=>{
      console.log(error);
      this.btnguardar = false;
      this.toastr.error('No se pudo crear.', 'Error!');
    });
    /*this.openmodalcargando.nativeElement.click();
    if (this.NuevoUsuario.tipoIdent == "" || this.NuevoUsuario.tipoIdent == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Seleccionar un tipo de identificación.', 'Advertencia!');
    } else if (this.NuevoUsuario.identificacion == "" || this.NuevoUsuario.identificacion == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar número de identificación.', 'Advertencia!');
    } else if (this.NuevoUsuario.nombres == "" || this.NuevoUsuario.nombres == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar nombres.', 'Advertencia!');
    } /*else if (this.email1 == "" || this.email1 == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar correo electróico.', 'Advertencia!');
    } else if (this.email2 == "" || this.email2 == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar correo electrónico.', 'Advertencia!');
    } else if (this.NuevoUsuario.telefono == "" || this.NuevoUsuario.telefono == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar número telefonico.', 'Advertencia!');
    } else if (this.NuevoUsuario.extencion == "" || this.NuevoUsuario.extencion == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar extención.', 'Advertencia!');
    } else if (this.NuevoUsuario.cargo == "" || this.NuevoUsuario.cargo == null){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Ingresar cargo.', 'Advertencia!');
    } else if (this.email1 != this.email2){
      this.continuar = false;
      this.btnguardar = false;
      this.toastr.warning('Correo no coincide.', 'Advertencia!');
    } else{
      if (this.continuar){
        this.btnguardar = true;
        //this.NuevoUsuario.correo = this.email1;
        //console.log(this.NuevoUsuario);
        this.api.nuevoUsuario(this.NuevoUsuario).subscribe(data=>{
          //console.log(data);
          //this.closemodacargando.nativeElement.click();
          this.toastr.success('Usuario creado.', 'OK!');
          this.router.navigate(['usuarios']);
        },error=>{
          console.log(error);
          //this.closemodacargando.nativeElement.click();
          this.btnguardar = false;
          this.toastr.error('No se pudo crear.', 'Error!');
        });
      } else {
        this.btnguardar = false;
        this.toastr.error('No se pudo crear.', 'Error!');
      }
    }*/
  }

  regresar(){
    this.router.navigate(['usuarios']);
  }
}
